import { useEffect } from 'react';
import axios from 'axios';
import { collection, addDoc, query, where, getDocs, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';

const API_URL = 'https://sorteosrd.com/api/sorteosrd-results/217XUR6ivy8A1NdI4SKcnAa9YGZRV7w3';

const validDescriptions = [
  'Florida Lottery 1:30 PM',
  'Florida 10:50 PM',
  'King Lottery 12:30 PM',
  'King Lottery 7:30 PM',
  'New York Lottery 3:30 PM',
  'New York Lottery 10:30 PM',
  'Loto Real 12:55 PM',
  'La Suerte Dominicana 12:30PM',
  'La Suerte 6:00 PM',
  'La Primera 12:00PM',
  'La Primera 8:00 PM',
  'Quiniela Loteka 7:55 PM',
  'Quiniela LoteDom 5:55 PM',
  'Anguila 10:00 AM',
  'Anguila 1:00 PM',
  'Anguila 6:00 PM',
  'Anguila 9:00 PM',
  'Loteria Nacional 2:30 PM Gana Más',
  'Loteria Nacional 8:50 PM',
  'Quiniela Pale Leidsa 8:55 PM / Dom 3:00 PM',
];

const getCurrentDateRD = () => {
  return new Date().toLocaleDateString('en-US', { timeZone: 'America/Santo_Domingo' });
};

export const useLotteryResults = () => {
  const fetchResults = async () => {
    try {
      const { data } = await axios.get(API_URL);
      const today = getCurrentDateRD();

      if (!Array.isArray(data)) {
        console.warn('API no devolvió un arreglo:', data);
        return;
      }

      const todaysResults = data.filter((result) => {
        const resultDateRD = new Date(result.created_at).toLocaleDateString('en-US', { timeZone: 'America/Santo_Domingo' });
        return validDescriptions.includes(result.descripcion) && resultDateRD === today;
      });

      for (const result of todaysResults) {
        const uniqueId = `${result.descripcion}-${result.created_at}`;

        // Verificar si el resultado ya se publicó anteriormente
        const messagesRef = collection(db, 'messages');
        const querySnapshot = await getDocs(
          query(messagesRef, where('uniqueId', '==', uniqueId))
        );

        if (querySnapshot.empty) {
          const messageText = `🎲 <strong>${result.descripcion}</strong> 🎲<br/>
          🔢 Números ganadores: <strong>${result.num1}, ${result.num2}, ${result.num3}</strong><br/>
          📅 Hora: ${new Date(result.created_at).toLocaleString('es-DO', { timeZone: 'America/Santo_Domingo' })}`;

          await addDoc(messagesRef, {
            text: messageText,
            username: '🎰 Resultados Lotería',
            avatarUrl: 'https://srv943-files.hstgr.io/2251f2e6efdc1fb8/files/public_html/logo-chatsrd.png',
            timestamp: Timestamp.fromDate(new Date(result.created_at)), // Aquí se usa la fecha exacta del sorteo
            role: 'sistema',
            uniqueId,
          });
        } else {
          console.log('Resultado ya publicado anteriormente:', uniqueId);
        }
      }
    } catch (error) {
      console.error('Error al obtener resultados:', error);
    }
  };

  useEffect(() => {
    fetchResults();
    const interval = setInterval(fetchResults, 120000); // cada 2 minutos

    return () => clearInterval(interval);
  }, []);
};
